// True from a click on a transaction tab until the gateways response of the
// new tab arrives, or until it is clear that no gateways request can follow
// the switch (see switchTransactionTab). It keeps the transaction tabs locked
// for the switch's own gap: the time between the click and the request.
//
// RESET_TAB_STATE is the first action of a tab switch, so the lock is raised
// by the same dispatch that starts the switch, before anything else changes.
const tabSwitchAwaitingGateways = (state, action) => {
  if (state === undefined) {
    return false;
  }
  switch (action.type) {
    case 'RESET_TAB_STATE':
      return true;
    case 'TAB_SWITCH_GATEWAYS_SETTLED':
      return false;
    default:
      return state.tabSwitchAwaitingGateways;
  }
};

export { tabSwitchAwaitingGateways };
